import React from 'react'

import { useFieldsFromApi } from '../../../../utils/helpers/fields'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFieldsState = () => React.useContext(Context)
export const useFields = () => useFieldsState()?.fields

const FieldsLoader = ({ children, origin }) => {
  const { data, ...state } = useFieldsFromApi(origin)

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FieldsLoader
